import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const CurrencyField = ({ id, name, value, onChange, onBlur }) => {
  const [isEditing, setIsEditing] = useState(false);

  const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2
    });

    return formatter.format(number);
  };

  const toggleEditing = (event) => {
    setIsEditing(!isEditing);
    onBlur(event);
  };

  return (
    <div>
      {isEditing ? (
        <Form.Control
          id={id}
          type="number"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          onBlur={toggleEditing}
        />
      ) : (
        <Form.Control
          id={id}
          type="text"
          name={name}
          value={toCurrency(value)}
          onFocus={toggleEditing}
          readOnly // Prevents unwanted user edits while in display mode
          style={{ backgroundColor: "#fff" }} // Bootstrap greys out readOnly inputs; this field is still editable via focus
        />
      )}
    </div>
  );
};

CurrencyField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Allow numbers too
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired
};

export default CurrencyField;